import React, { FC, PropsWithChildren } from 'react';

export type HeaderLogoProps = { src: string; link?: string; linkAs?: FC<PropsWithChildren<{ to: string }>> };

export const HeaderLogo = ({ src, link = '/', linkAs: LinkAs }: HeaderLogoProps) => {
  const logoCmpt = <img className="home-logo" src={src} alt="logo" />;
  return LinkAs ? <LinkAs to={link}>{logoCmpt}</LinkAs> : <a href={link}>{logoCmpt}</a>;
};
